import styled from 'styled-components'
import { theme, progressiveBreakpoints } from '../../constants/theme'

export const Container = styled.div`
  position: fixed;
  left: 8px;
  right: 8px;
  top: calc(100% - 8px);
  transition: 0.5s all;
  transform: ${({ active }) =>
    active ? 'translateY(-100%)' : 'translateY(8px)'};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: auto;
  max-width: 100%;
  margin: 0 auto;
  background-color: #8ed6c9;
  border-radius: 4px;
  overflow: hidden;
  padding: 12px;
  box-sizing: border-box;
  z-index: 10000000000; /* Needed to get past intercom */
  @media ${progressiveBreakpoints.desktopSmall} {
    top: 100%;
    bottom: auto;
    left: 50%;
    right: auto;
    width: 100%;
    transform: translateX(-50%)
      ${({ active }) => (active ? 'translateY(-110%)' : '')};
    max-width: 746px;
    padding: 16px;
  }
  p {
    flex: 1;
    display: block;
    width: 100%;
    color: #424449;
    font-weight: 700;
    font-family: ${theme.fonts.fontFamily};
    font-size: 12px;
    line-height: 18px;
    margin: 0;

    @media ${progressiveBreakpoints.desktopSmall} {
      font-size: 18px;
      line-height: 26px;
    }
    a {
      font-weight: 400;
      display: block;
      color: #424449;
      &:hover,
      &:focus {
        text-decoration: none;
      }
      @media ${progressiveBreakpoints.desktopSmall} {
        padding-left: 10px;
        display: inline-block;
      }
    }
  }
  button {
    flex: 1;
    border: 0;
    height: 28px;
    line-height: 28px;
    max-width: 86px;
    color: #fff;
    background-color: #424449;
    border-radius: 3px;
    font-size: 14px;
    font-family: ${theme.fonts.fontFamily};
    font-weight: 700;
    &:hover,
    &:focus {
      cursor: pointer;
      opacity: 0.8;
    }
    @media ${progressiveBreakpoints.desktopSmall} {
      height: 48px;
      line-height: 48px;
      max-width: 185px;
    }
  }
`
